import { useEffect, useState } from "react";
import { Form, Col, Row, Button } from "antd";
import useGet from "../../../global/hooks/useGet";
import usePost from "../../../global/hooks/usePost";
import usePut from "../../../global/hooks/usePut";
import useDelete from "../../../global/hooks/useDelete";
import CustomInput from "../../../global/components/inputWidgets/CustomInput";
import CustomSelect from "../../../global/components/inputWidgets/CustomSelect";
import { useNavigate, useParams } from "react-router-dom";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";

import {
  CheckCircleOutlined,
  CloseOutlined,
  DeleteOutlined,
  EditOutlined,
  UnorderedListOutlined,
  InfoCircleOutlined,
  ContactsOutlined,
  DesktopOutlined,
  SettingOutlined,
  LoginOutlined,
  FolderOpenOutlined,
} from "@ant-design/icons";
// import CustomSwitch from "../../../global/components/inputWidgets/CustomSwitch";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import CommonButton from "../../../global/components/CommonButton";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import ConfirmModal from "../../../global/components/ConfirmModal";
import { FaGlobe, FaUserTag } from "react-icons/fa6";
import { FaSearch } from "react-icons/fa";
import SingleSelectCheckboxGroup from "../../../global/components/inputWidgets/SingleSelectCheckboxGroup";
import AccountCreationModal from "../../../global/components/AccountCreationModal";
import OemIcon from "../../../assets/images/vectors/SideBarIcons/OemIcon";
import DealerIcon from "../../../assets/images/vectors/SideBarIcons/DealerIcon";
import AccountIcon from "../../../assets/images/vectors/SideBarIcons/AccountIcon";
import CustomCheckbox from "../../../global/components/inputWidgets/CustomCheckBox";
import { hasRole } from "../../../global/hooks/getUserRole";
import CommonModal from "../../../global/components/CommonModal";
import LicenseIcon from "../../../assets/images/vectors/SideBarIcons/LicenseIcon";
import { LicenseSelectForm } from "../../Device/Components/LicenseSelectForm";
import { macValidator } from "../../../global/utils/macValidator";

export const MySiteForm = ({ type }) => {
  const [selectedValues, setSelectedValues] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [autoLogin, setAutoLogin] = useState(0);
  const [defaultData, setDefaultData] = useState({
    DealerNo: null,
    OemNo: null,
    CustomerNo: null,
  });
  const [OemNo, setOemNo] = useState(null);
  const [dealerNo, setDealerNo] = useState(null);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [sitetype, setSiteType] = useState(0);
  const [selectedRow, setSelectedRow] = useState([]);
  const [showCommonModal, setShowCommonModal] = useState(false);
  const [licenseSiteType, setLicenseSiteType] = useState(null);

  const [form] = Form.useForm();
  const { id } = useParams();
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const navigate = useNavigate();
  const [defaultLicenseDevicesValue, setDefaultLicenseDevicesValue] = useState({
    channels: null,
    facegates: null,
    locksets: null,
    contlocks: null,
    subnodes: null,
    intercoms: null,
    sicucoms: null,
    invitations: null,
    // storages: null,
  });

  const url = id
    ? `${process.env.REACT_APP_API_URL}/api/sites/${id}/`
    : undefined;

  const optionUrl = `${process.env.REACT_APP_API_URL}/api/devices/options/`;
  const postUrl = `${process.env.REACT_APP_API_URL}/api/sites/`;
  const putUrl = `${process.env.REACT_APP_API_URL}/api/sites/${id}/`;
  const deleteUrl = `${process.env.REACT_APP_API_URL}/api/sites/${id}/`;
  const { data, loading, error, refetch } = useGet(url);

  const {
    data: optionsData,
    error: optionDataError,
    refetch: optionDataRefetch,
  } = useGet(optionUrl);
  const [params, setParams] = useState({
    limit: 10,
    Mac: "",
    SiteKey: "",
  });
  const query = new URLSearchParams(params).toString();
  const searchurl =
    params.Mac && params.SiteKey
      ? `${process.env.REACT_APP_API_URL}/api/sites/?${query}`
      : undefined;
  const { data: searchData, loading: searchDataLoading } = useGet(searchurl);

  const dealerOptionsUrl =
    OemNo || data?.data?.OemNo || defaultData?.OemNo
      ? `${process.env.REACT_APP_API_URL}/api/dealers/oems/${
          OemNo
            ? OemNo
            : defaultData?.OemNo
            ? defaultData.OemNo
            : data?.data?.OemNo
        }/dealers/`
      : null;

  const {
    data: dealerOptions,
    loading: dealerOptionsLoading,
    error: dealerOptionsError,
    refetch: delaerOpRefetch,
  } = useGet(dealerOptionsUrl);

  const custmerOptionsUrl =
    dealerNo || data?.data?.DealerNo || defaultData?.DealerNo
      ? `${process.env.REACT_APP_API_URL}/api/dealers/${
          dealerNo
            ? dealerNo
            : defaultData?.DealerNo
            ? defaultData.DealerNo
            : data?.data?.DealerNo
        }/customers/`
      : hasRole(7, 8, 9) && userData?.dealer_no
      ? `${process.env.REACT_APP_API_URL}/api/dealers/${userData?.dealer_no}/customers/`
      : null;

  const licenseInfoUrl =
    selectedRow[0]?.LicenseNo &&
    `${process.env.REACT_APP_API_URL}/api/licenses/${selectedRow[0]?.LicenseNo}/`;

  const {
    data: custmerOptions,
    loading: custmerOptionsLoading,
    error: custmerOptionsError,
    refetch: customerDataRefetch,
  } = useGet(custmerOptionsUrl);

  const {
    data: postData,
    error: postError,
    postData: postAction,
    loading: postLoading,
  } = usePost(postUrl);
  const {
    data: putData,
    error: putError,
    putData: putAction,
    loading: putLoading,
  } = usePut(putUrl);
  const {
    data: deletedData,
    error: deletedDataError,
    deleteData,
  } = useDelete(deleteUrl);

  const { data: individualLicenseData, error: individualLicenseError } =
    useGet(licenseInfoUrl);

  const modifiedSiteTypes = getModifiedResponse(optionsData, "sitetype");
  const modifiedProducts = getModifiedResponse(optionsData, "products");
  const modifiedModels = getModifiedResponse(optionsData, "models");

  const modifiedOp = optionsData?.data?.options?.map((entry, index) => {
    // const safeName = entry?.name?.replace(/\s+/g, "_")?.toLowerCase();
    // const safeTag = entry?.tag?.replace(/\s+/g, "_")?.toLowerCase();

    return {
      value: `${entry?.value}`,
      // tag: entry.tag.toLowerCase().replace(/\s+/g, ""),
      label: entry.name,
    };
  });

  const modifiedOpValues =
    selectedValues?.length > 0
      ? selectedValues?.map((val) => {
          const [item, originalValue] = val?.split("-");
          return [Number(item), Number(originalValue)];
        })
      : [];

  const handleCreateNew = (type) => {
    setModalType(type);
    setIsOpenModal(true);
  };

  useEffect(() => {
    optionDataRefetch();
    delaerOpRefetch();
    customerDataRefetch();
    if (
      defaultData?.OemNo ||
      defaultData?.DealerNo ||
      defaultData?.CustomerNo
      // ||
      // defaultData?.ProductionNo
    ) {
      form.setFieldsValue(defaultData);
    }
  }, [defaultData]);

  const modifiedOems = getModifiedResponse(optionsData, "oems");
  const modifiedDealers = getModifiedResponse(dealerOptions, null);
  const modifiedCustomers = getModifiedResponse(custmerOptions, null);
  // const modifiedOptions = {
  //   channels: createModifiedOptions(optionsData, "channels"),
  //   facegates: createModifiedOptions(optionsData, "facegates"),
  //   locksets: createModifiedOptions(optionsData, "locksets"),
  //   contLocks: createModifiedOptions(optionsData, "contlocks"),
  //   subnodes: createModifiedOptions(optionsData, "subnodes"),
  //   intercoms: createModifiedOptions(optionsData, "intercoms"),
  //   sicucoms: createModifiedOptions(optionsData, "sicucoms"),
  //   invitations: createModifiedOptions(optionsData, "invitations"),
  //   storages: createModifiedOptions(optionsData, "storages"),
  // };
  // const {
  //   channels: modifiedChannels,
  //   facegates: modifiedFacegates,
  //   locksets: modifiedLocksets,
  //   contLocks: modifiedContLocks,
  //   subnodes: modifiedSubnodes,
  //   intercoms: modifiedIntercoms,
  //   sicucoms: modifiedSicucoms,
  //   invitations: modifiedInvitations,
  //   storages: modifiedStorages,
  // } = modifiedOptions;
  // console.log(userData, "OemNo");
  const onFinish = async (values) => {
    try {
      if (id) {
        const modifiedValue = {
          ...values,
          DealerNo: values?.DealerNo
            ? values?.DealerNo
            : ![1, 2, 3, 4, 5, 6].includes(userData?.role_value)
            ? data?.data?.DealerNo
            : null,
          CustomerNo: values?.CustomerNo
            ? values?.CustomerNo
            : ![1, 2, 3, 4, 5, 6, 7, 8, 9].includes(userData?.role_value)
            ? data?.data?.CustomerNo
            : null,
          OemNo: values?.OemNo
            ? values?.OemNo
            : ![1, 2, 3].includes(userData?.role_value)
            ? data?.data?.OemNo
            : null,
          DeviceDesc: values?.DeviceDesc,
          UserId: values?.UserId,
          Password: values?.Password,
          AutoLogin: values?.AutoLogin,
          Options: values?.Options?.map((item) => Number(item)),
          Type: Number(values.Type),
          Channel: values.Channel || 0,
          Lockset: values.Lockset || 0,
          ContLock: values.ContLock || 0,
          Facegate: values.Facegate || 0,
          Subnode: values.Subnode || 0,
          Intercom: values.Intercom || 0,
          Sicucom: values.Sicucom ? values.Sicucom / 100 : 0,
          Invitation: values.Invitation ? values.Invitation / 100 : 0,
        };
        // console.log(modifiedValue, " modifiedValue");
        await putAction(modifiedValue);
      } else {
        const modifiedValue = {
          ...values,
          LicenseNo: selectedRow?.[0]?.LicenseNo,
          Options: values?.Options?.map((item) => Number(item)),
          Type: Number(values.Type),
          Channel: values.Channel || 0,
          Lockset: values.Lockset || 0,
          ContLock: values.ContLock || 0,
          Facegate: values.Facegate || 0,
          Subnode: values.Subnode || 0,
          Intercom: values.Intercom || 0,
          Sicucom: values.Sicucom ? values.Sicucom / 100 : 0,
          Invitation: values.Invitation ? values.Invitation / 100 : 0,
          NodeType: 1,
          DealerNo: values?.DealerNo
            ? values?.DealerNo
            : hasRole(7, 8, 9)
            ? userData?.dealer_no
            : null,
          OemNo: values?.OemNo
            ? values?.OemNo
            : hasRole(7, 8, 9)
            ? userData?.oem_no
            : null,
        };

        await postAction(modifiedValue);
      }
    } catch (error) {
      openErrorNotification("Something went wrong.");
      console.log(error);
    }
  };

  const onReset = () => {
    navigate(-1);
  };

  const onDeleteConfirm = async () => {
    try {
      await deleteData();
    } catch (error) {
      openErrorNotification("Something went wrong.");
    }
    setShowModal(false);
  };

  useEffect(() => {
    const getDeviceInfoById = () => {
      try {
        form.resetFields();
        if (data?.data) {
          form.setFieldsValue({
            DeviceDesc: data?.data?.DeviceDesc || "",
            UserId: data?.data?.UserId || "",
            Password: data?.data?.Password,
            AutoLogin: data?.data?.AutoLogin,
            Blocked: data?.data?.Blocked || 0,
            DeviceName: data?.data?.DeviceName || "",
            DealerNo: data?.data?.DealerNo,
            CustomerNo: data?.data?.CustomerNo,
            SiteType: data?.data?.SiteType,
            Type: data?.data?.Type,
            AddTime: data?.data?.AddTime
              ? new Date(data.data.AddTime)
                  .toISOString()
                  .slice(0, 19)
                  .replace("T", " ")
              : null,
            ActTime: data?.data?.ActTime
              ? new Date(data.data.ActTime)
                  .toISOString()
                  .slice(0, 19)
                  .replace("T", " ")
              : null,
            StartTime: data?.data?.StartTime
              ? new Date(data.data.StartTime)
                  .toISOString()
                  .slice(0, 19)
                  .replace("T", " ")
              : null,
            EndTime: data?.data?.EndTime
              ? new Date(data.data.EndTime)
                  .toISOString()
                  .slice(0, 19)
                  .replace("T", " ")
              : null,
            Mac: data?.data?.Mac || "",
            SiteKey: data?.data?.SiteKey || "",
            LicenseKey: data?.data?.LicenseKey || "",
            // Address: data?.data?.Address || "",
            ProxyServer: data?.data?.ProxyAddr,
            SecurePort: data?.data?.SecurePort
              ? String(data?.data?.SecurePort)
              : "",
            DebugPort: data?.data?.DebugPort
              ? String(data?.data?.DebugPort)
              : "",
            Version: data?.data?.Version ? String(data?.data?.Version) : "",
            Https: data?.data?.Https ? "Yes" : "No",
            Timezone: data?.data?.Timezone ? String(data?.data?.Timezone) : "",
            Online: data?.data?.Online ? "Yes" : "No",
            Product: data?.data?.Product,
            Model: data?.data?.Model,
            OemNo: data?.data?.OemNo,
            Options: data.data.Options?.map((item) => String(item)),
            Channel: data?.data?.Channel,
            Lockset: data?.data?.Lockset,
            Facegate: data?.data?.Facegate,
            Subnode: data?.data?.Subnode,
            ContLock: data?.data?.ContLock,
            Intercom: data?.data?.Intercom,
            Sicucom: data.data.Sicucom ? data.data.Sicucom * 100 : null,
            Invitation: data.data.Invitation
              ? data.data.Invitation * 100
              : null,
            FirstName: data?.data?.FirstName
              ? String(data?.data?.FirstName)
              : "",
            LastName: data?.data?.LastName ? String(data?.data?.LastName) : "",
            Company: data?.data?.Company ? String(data?.data?.Company) : "",
            Email: data?.data?.Email ? String(data?.data?.Email) : "",
            Phone: data?.data?.Phone ? String(data?.data?.Phone) : "",
            Address: data?.data?.Address ? String(data?.data?.Address) : "",
            Address2: data?.data?.Address2 ? String(data?.data?.Address2) : "",
            InstallType: data?.data?.InstallType
              ? String(data?.data?.InstallType)
              : "",
            Suggestion: data?.data?.Suggestion
              ? String(data?.data?.Suggestion)
              : "",
            // Storage: data?.data?.Storage,
          });
          setDefaultData((prev) => ({
            ...prev,
            OemNo: data?.data?.OemNo || null,
            DealerNo: data?.data?.DealerNo || null,
            CustomerNo: data?.data?.CustomerNo || null,
          }));
          setAutoLogin(data?.data?.AutoLogin);
          // if (data.data.Options && modifiedOp) {
          //   const filtered = modifiedOp
          //     .filter((op) => {
          //       const [item, originalValue] = op?.value?.split("-");
          //       return data?.data?.Options.some(
          //         ([selectedItem, selectedOriginalValue]) =>
          //           Number(item) === selectedItem &&
          //           Number(originalValue) === selectedOriginalValue
          //       );
          //     })
          //     .map((op) => op?.value);
          //   setSelectedValues(filtered || []);
          //   setDefaultOptionsValue(filtered || []);
          // }
          // setDeafultModel(data.data.Model || null);
          // setDefaultLicenseDevicesValue({
          //   channels: data.data.Channel || null,
          //   locksets: data.data.Lockset || null,
          //   facegates: data.data.Facegate || null,
          //   contlocks: data.data.ContLock || null,
          //   subnodes: data.data.Subnode || null,
          //   intercoms: data.data.Intercom || null,
          //   sicucoms: data.data.Sicucom || null,
          //   invitations: data.data.Invitation || null,
          //   // storages: data.data.Storage || null,
          // });
          setSiteType(data.data.SiteType || 0);
        } else {
          console.warn("No data found for the given ID");
        }
      } catch (error) {
        console.log({ error });
        openErrorNotification("Error fetching data!");
      }
    };

    getDeviceInfoById();
  }, [id, data, form, type]);

  useEffect(() => {
    if (!type && searchData) {
      if (searchData?.data.length) {
        const data = searchData?.data?.[0];

        form.setFieldsValue({
          DeviceName: data?.DeviceName || "",
          SiteType: data?.SiteType,
          Mac: data?.Mac,
          SiteKey: data?.SiteKey,
          LicenseKey: data?.LicenseKey,
        });
      } else if (!searchData?.data.length) {
        openErrorNotification("No Site Found");
      }
    }
  }, [type, searchData]);

  // Set default field value
  useEffect(() => {
    if (!id) {
      form.setFieldsValue({
        Product: modifiedProducts[0]?.value,
        Model: modifiedModels[0]?.value,
        Options: [],
        SiteType: hasRole(7, 8, 9)
          ? modifiedSiteTypes[3]?.value
          : modifiedSiteTypes[0]?.value,
        // Channel: modifiedChannels[0]?.value,
        // Lockset: modifiedLocksets[0]?.value,
        // Facegate: modifiedFacegates[0]?.value,
        // Subnode: modifiedSubnodes[0]?.value,
        // ContLock: modifiedContLocks[0]?.value,
        // Intercom: modifiedIntercoms[0]?.value,
        // Sicucom: modifiedSicucoms[0]?.value,
        // Invitation: modifiedInvitations[0]?.value,
        // Storage: modifiedStorages[0]?.value,
      });
      if (hasRole(7, 8, 9)) {
        setSiteType(3);
      }
    }
  }, [optionsData]);

  useEffect(() => {
    if (data?.data?.SiteType && !form.getFieldValue("DealerNo")) {
      if (data?.data?.SiteType === 3 && type === "edit") {
        return;
      }
      if (id) {
        return;
      }
      form.setFieldsValue({
        SiteType: hasRole(7, 8, 9) ? data?.data?.SiteType : 0,
      });
    }
  }, [form.getFieldValue("DealerNo")]);

  //toat for create
  useEffect(() => {
    if (postError) {
      openErrorNotification(
        postError?.response?.data?.message || "Something went wrong"
      );
    } else if (!postError && postData) {
      openConfirmNotification("Success");
      navigate(-1);
    }
  }, [postError, postData]);

  //toat for update
  useEffect(() => {
    if (putError) {
      openErrorNotification(
        putError?.response?.data?.message || "Something went wrong"
      );
    } else if (!putError && putData) {
      openConfirmNotification("Success");
      refetch();
      navigate(-1);
      // navigate("/site");
    }
  }, [putData, putError]);

  //toast for delete
  useEffect(() => {
    if (deletedData && !deletedDataError) {
      openConfirmNotification("Success");
      navigate("site");
    } else if (deletedDataError) {
      openErrorNotification(
        deletedDataError?.response?.data?.message || "Something went wrong"
      );
    } else {
      return;
    }
  }, [deletedData, deletedDataError]);

  useEffect(() => {
    if (data?.data?.SiteType === 3 && type === "edit") {
      return;
    }
    if (!form.getFieldValue("DealerNo") && !id) {
      form.setFieldsValue({
        SiteType: hasRole(7, 8, 9) ? 3 : 0,
      });
    } else if (
      form.getFieldValue("DealerNo") &&
      licenseSiteType &&
      type !== "edit" &&
      type !== "info"
    ) {
      form.setFieldsValue({
        SiteType: licenseSiteType,
      });
    }
  }, [form.getFieldValue("DealerNo"), form.getFieldValue("OemNo")]);

  const breadcrumbItems = [
    {
      label: "Site",
      href: "/site",
    },
    {
      label: id ? (type === "info" ? "Information" : "Edit") : "Add",
      href: id
        ? type === "info"
          ? `/site/info/${id}`
          : `/site/edit/${id}`
        : "/site/add",
    },
  ];

  const buttonsData =
    type === "info"
      ? [1, 2, 3].includes(userData?.role_value)
        ? [
            {
              label: "Edit",
              icon: <EditOutlined />,
              onClick: () => {
                navigate(`/site/edit/${id}`);
              },
            },
            {
              label: "Delete",
              icon: <DeleteOutlined />,
              onClick: () => {
                setShowModal(true);
              },
            },
            {
              label: "List",
              icon: <UnorderedListOutlined />,
              onClick: () => {
                navigate(-1);
              },
            },
          ]
        : [4, 5, 6, 7, 8, 9].includes(userData?.role_value)
        ? [
            {
              label: "Edit",
              icon: <EditOutlined />,
              onClick: () => {
                navigate(`/site/edit/${id}`);
              },
            },
            // {
            //   label: "License",
            //   icon: <ContactsOutlined />,
            //   onClick: () => {
            //     navigate(`/site/license/${id}`);
            //   },
            // },
            // {
            //   label: "Delete",
            //   icon: <DeleteOutlined />,
            //   onClick: () => {
            //     setShowModal(true);
            //   },
            // },
            {
              label: "List",
              icon: <UnorderedListOutlined />,
              onClick: () => {
                navigate(-1);
              },
            },
          ]
        : [
            {
              label: "List",
              icon: <UnorderedListOutlined />,
              onClick: () => {
                navigate(-1);
              },
            },
          ]
      : type === "edit"
      ? [
          {
            label: "Apply",
            icon: <CheckCircleOutlined />,
            onClick: () => form.submit(),
            loading: putLoading,
          },
          {
            label: "Cancel",
            icon: <CloseOutlined />,
            onClick: onReset,
          },
        ]
      : hasRole(7, 8, 9)
      ? [
          {
            label: "Apply",
            icon: <CheckCircleOutlined />,
            onClick: () => form.submit(),
            loading: postLoading || putLoading,
          },
          {
            label: "Cancel",
            icon: <CloseOutlined />,
            onClick: onReset,
          },
        ]
      : [
          {
            label: "License Select",
            icon: <FolderOpenOutlined />,
            onClick: () => {
              setShowCommonModal(true);
            },
          },
          {
            label: "Apply",
            icon: <CheckCircleOutlined />,
            onClick: () => form.submit(),
            loading: postLoading || putLoading,
          },
          {
            label: "Cancel",
            icon: <CloseOutlined />,
            onClick: onReset,
          },
        ];

  // const isOneTime = (category, valueToCheck) => {
  //   return optionsData?.data?.[category]
  //     ?.filter((item) => item.tag === "One Time")
  //     ?.map((item) => item.value)
  //     ?.includes(valueToCheck);
  // };

  // const modifiedOneTimeOptions = isOneTime("models", deafultModel);
  // const isChannelOneTime = isOneTime(
  //   "channels",
  //   defaultLicenseDevicesValue.channels
  // );
  // const isLocksetOneTime = isOneTime(
  //   "locksets",
  //   defaultLicenseDevicesValue.locksets
  // );
  // const isFacegatesOneTime = isOneTime(
  //   "facegates",
  //   defaultLicenseDevicesValue.facegates
  // );
  // const isSubnodesOneTime = isOneTime(
  //   "subnodes",
  //   defaultLicenseDevicesValue.subnodes
  // );
  // const isContLocksOneTime = isOneTime(
  //   "contlocks",
  //   defaultLicenseDevicesValue.contlocks
  // );
  // const isIntercomsOneTime = isOneTime(
  //   "intercoms",
  //   defaultLicenseDevicesValue.intercoms
  // );
  // const isSicucomsOneTime = isOneTime(
  //   "sicucoms",
  //   defaultLicenseDevicesValue.sicucoms
  // );
  // const isInvitationsOneTime = isOneTime(
  //   "invitations",
  //   defaultLicenseDevicesValue.invitations
  // );
  // const isStoragesOneTime = isOneTime(
  //   "storages",
  //   defaultLicenseDevicesValue.storages
  // );

  useEffect(() => {
    if (
      id &&
      type === "edit" &&
      [3, 6, 10, 11, 12].includes(userData?.role_value)
    ) {
      navigate("/");
    }
  }, []);

  return (
    <div>
      <AccountCreationModal
        isOpenModal={isOpenModal}
        modalType={modalType}
        setIsOpenModal={setIsOpenModal}
        setDefaultData={setDefaultData}
        defaultData={defaultData}
        setModalType={setModalType}
        isModal={true}
        isModalForm={true}
        title={
          <div className="flex items-center bg-gray-200 p-2 rounded-md">
            {modalType === "OEM" ? (
              <OemIcon className="text-[15px] text-black ml-1" />
            ) : modalType === "Dealer" ? (
              <DealerIcon className="text-[15px] text-black ml-1" />
            ) : modalType === "Customer" ? (
              <AccountIcon className="text-[15px] text-black ml-1" />
            ) : null}
            <span className="text-[14px] font-[Poppins] text-black  ml-2">
              {isOpenModal ? `Add ${modalType}` : "Send Invitation"}
            </span>
          </div>
        }
      />
      <CommonModal
        title="Select License"
        icon={LicenseIcon}
        content={
          <LicenseSelectForm
            setSelectedRow={setSelectedRow}
            type="Initial License"
          />
        }
        isVisible={showCommonModal}
        onClose={() => setShowCommonModal(false)}
        width={900}
        onConfirm={() => {
          if (!individualLicenseData?.data) {
            openErrorNotification("Please select a license before apply.");
            return;
          }
          setSiteType(individualLicenseData.data.SiteType);
          form.setFieldsValue({
            Options: individualLicenseData?.data?.Options?.map((item) =>
              String(item)
            ),
            Product: individualLicenseData?.data?.Product,
            Model: individualLicenseData?.data?.Model,
            Type: individualLicenseData.data.Type,
            SiteType: !form.getFieldValue("DealerNo")
              ? 0
              : individualLicenseData.data.SiteType,
            // OemNo: individualLicenseData.data.OemNo,
            Invitation: individualLicenseData.data.Invitation
              ? individualLicenseData.data.Invitation * 100
              : undefined,
            Channel: individualLicenseData.data.Channel,
            Lockset: individualLicenseData.data.Lockset,
            Facegate: individualLicenseData.data.Facegate,
            Subnode: individualLicenseData.data.Subnode,
            ContLock: individualLicenseData.data.ContLock,
            Intercom: individualLicenseData.data.Intercom,
            Sicucom: individualLicenseData.data.Sicucom
              ? individualLicenseData.data.Sicucom * 100
              : undefined,
            // Storage: individualLicenseData.data.Storage,
          });
          setLicenseSiteType(individualLicenseData.data.SiteType);
          // if (individualLicenseData?.data?.Options && modifiedOp) {
          // const filtered = modifiedOp
          //   .filter((op) => {
          //     const [item, originalValue] = op?.value?.split("-");
          //     return individualLicenseData?.data?.Options.some(
          //       ([selectedItem, selectedOriginalValue]) =>
          //         Number(item) === selectedItem &&
          //         Number(originalValue) === selectedOriginalValue
          //     );
          //   })
          //   .map((op) => op.value);
          //   setSelectedValues(individualLicenseData?.data?.Options || []);
          // }
          setShowCommonModal(false);
        }}
      />
      <div className="pb-4 sticky -mt-4 pt-[6px] top-[55px] z-10 bg-[#f4f5f9]">
        <CommonBreadcrumb breadcrumbItems={breadcrumbItems}>
          <CommonButton buttonsData={buttonsData} />
        </CommonBreadcrumb>
      </div>

      <div className="">
        <Form
          validateTrigger={"onChange"}
          form={form}
          onFinish={onFinish}
          scrollToFirstError
          layout={"vertical"}
          autoComplete={"off"}

          // onValuesChange={(changedValues) => {
          //   console.log("Changed Field:", changedValues);
          // }}
        >
          {/* {!type && (
            <div className="mt-4 overflow-hidden border bg-white rounded-[4px]">
              <div className="flex items-center bg-gray-200 p-2.5">
                <FaSearch className="text-[18px] text-black " />
                <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                  Search
                </span>
              </div>
              <div className="px-2 pt-1 pb-3">
                <Row gutter={[16, 8]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput label="MAC" name="MacSearch" required />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Site Key"
                      name="SiteKeySearch"
                      required
                    />
                  </Col>
                </Row>
                <div className="flex justify-center">
                  <Button
                    loading={searchDataLoading}
                    type="primary"
                    className="mr-2 mt-3 h-[30px] font-medium"
                    onClick={() => {
                      if (!form.getFieldValue("MacSearch")) {
                        form.setFields([
                          {
                            name: "MacSearch",
                            errors: ["Please enter a MAC address"], // you can customize the error message
                          },
                        ]);
                        return; // stop execution if invalid
                      }
                      if (!form.getFieldValue("SiteKeySearch")) {
                        form.setFields([
                          {
                            name: "SiteKeySearch",
                            errors: ["Please enter a Site Key"], // you can customize the error message
                          },
                        ]);
                        return; // stop execution if invalid
                      }

                      setParams((prev) => ({
                        ...prev,
                        Mac: form.getFieldValue("MacSearch"),
                        SiteKey: form.getFieldValue("SiteKeySearch"),
                      }));
                    }}
                  >
                    <FaSearch />
                    Search
                  </Button>
                </div>
              </div>
            </div>
          )} */}
          {
            <div className="border bg-white rounded-[4px] overflow-hidden">
              <div className="flex items-center bg-gray-200 p-2.5">
                <FaGlobe className="text-[18px] text-black " />
                <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                  Site
                </span>
              </div>
              <div className="px-2 pt-1 pb-3">
                <Row gutter={[16, 8]}>
                  {
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Device Name"
                        name="DeviceName"
                        autoComplete="off"
                        disable={type === "info"}
                        loading={loading}
                      />
                    </Col>
                  }
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Description"
                      name="DeviceDesc"
                      disable={type === "info"}
                      loading={loading}
                    />
                  </Col>
                  {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomSelect
                      label="Auto Login"
                      name="AutoLogin"
                      options={[
                        { label: "Yes", value: 1 },
                        { label: "No", value: 0 },
                      ]}
                      placeholder="Please select"
                      disabled={type === "info"}
                      onChange={(value) => {
                        setAutoLogin(value);
                      }}
                    />
                  </Col>
                  {autoLogin === 1 && (
                    <>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <CustomInput
                          label="Username"
                          name="UserId"
                          disabled={type === "info"}
                          autoComplete="off"
                          required
                        />
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <CustomInput
                          label="Password"
                          name="Password"
                          type="password"
                          disabled={type === "info"}
                          autoComplete="new-password"
                          required
                        />
                      </Col>
                    </>
                  )} */}

                  {/* {type !== "edit" && (
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomSelect
                        label="Site Type"
                        name="SiteType"
                        options={modifiedSiteTypes}
                        placeholder="Please select"
                        disabled
                      />
                    </Col>
                  )} */}
                  {[1, 2, 3].includes(userData?.role_value) && (
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomSelect
                        label="OEM"
                        name="OemNo"
                        options={modifiedOems}
                        placeholder="Please select"
                        // value={form.getFieldValue("OemNo")}
                        disabled={type === "info"}
                        required
                        onChange={(value) => {
                          setDefaultData((prev) => ({
                            ...prev,
                            OemNo: value,
                            DealerNo: null,
                            CustomerNo: null,
                          }));
                          setOemNo(value);
                          setDealerNo(null);
                          form.setFieldsValue({
                            DealerNo: null,
                            CustomerNo: null,
                            SiteType: hasRole(7, 8, 9)
                              ? data?.data?.SiteType
                              : 0,
                          });
                        }}
                        handleCreateNew={handleCreateNew}
                        type={"OEM"}
                        loading={loading}
                        allowClear={false}
                      />
                    </Col>
                  )}
                  {[1, 2, 3, 4, 5, 6].includes(userData?.role_value) && (
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomSelect
                        label="Dealer"
                        name="DealerNo"
                        options={modifiedDealers}
                        placeholder="Please select"
                        disabled={type === "info" || !defaultData?.OemNo}
                        onChange={(value) => {
                          setDefaultData((prev) => ({
                            ...prev,
                            DealerNo: value,
                            CustomerNo: null,
                          }));
                          setDealerNo(value);
                          form.setFieldsValue({
                            CustomerNo: null,
                          });
                          if (!value) {
                            form.setFieldsValue({
                              SiteType: hasRole(7, 8, 9)
                                ? data?.data?.SiteType
                                : 0,
                            });
                          }
                        }}
                        handleCreateNew={handleCreateNew}
                        type={"Dealer"}
                        loading={loading}

                        // customPlaceholderColor
                      />
                    </Col>
                  )}
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9].includes(
                    userData?.role_value
                  ) && (
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomSelect
                        label="Customer"
                        name="CustomerNo"
                        options={modifiedCustomers}
                        placeholder="Please select"
                        disabled={
                          type === "info" ||
                          (!defaultData?.DealerNo && !hasRole(7, 8, 9))
                        }
                        handleCreateNew={handleCreateNew}
                        type={"Customer"}
                        loading={loading}
                      />
                    </Col>
                  )}
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomSelect
                      label="Site Type"
                      name="SiteType"
                      options={
                        ["edit", "info"].includes(type)
                          ? form.getFieldValue("SiteType") === 3
                            ? modifiedSiteTypes?.filter(
                                (item) => item.value === 3
                              )
                            : form.getFieldValue("SiteType") === 4
                            ? modifiedSiteTypes?.filter(
                                (item) => item.value === 4
                              )
                            : hasRole(7, 8, 9) &&
                              form.getFieldValue("SiteType") == null
                            ? modifiedSiteTypes?.filter((item) =>
                                [3, 4].includes(item.value)
                              )
                            : modifiedSiteTypes?.filter(
                                (item) => ![3, 4].includes(item.value)
                              )
                          : hasRole(7, 8, 9)
                          ? modifiedSiteTypes?.filter((item) =>
                              [3, 4].includes(item.value)
                            )
                          : modifiedSiteTypes
                      }
                      placeholder="Please select"
                      loading={loading}
                      disabled={type === "info"}
                      onChange={(value) => {
                        setSiteType(value);
                      }}
                      allowClear={false}
                    />
                  </Col>
                  {[0, 1, 2].includes(sitetype) ? (
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="MAC"
                        name="Mac"
                        disable={id || type === "info"}
                        loading={loading}
                        rules={[{ validator: macValidator }]}
                        required={[0, 1, 2].includes(sitetype)}
                      />
                    </Col>
                  ) : null}
                  {[0, 1, 2].includes(sitetype) ? (
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomSelect
                        label="Product"
                        name="Product"
                        options={modifiedProducts}
                        placeholder="Please select"
                        disabled={
                          [3, 4].includes(form.getFieldValue("SiteType")) ||
                          type === "info" ||
                          userData?.role_value >= 10
                        }
                        required
                        loading={loading}
                      />
                    </Col>
                  ) : null}
                  {type === "info" && (
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Site Key"
                        name="SiteKey"
                        disabled
                        loading={loading}
                      />
                    </Col>
                  )}
                  {type === "info" && (
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="License Key"
                        name="LicenseKey"
                        disabled
                        loading={loading}
                      />
                    </Col>
                  )}
                  {type === "info" && (
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Add Time"
                        name="AddTime"
                        disabled
                        loading={loading}
                      />
                    </Col>
                  )}
                  {type === "info" && (
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Activate Time"
                        name="ActTime"
                        disabled
                        loading={loading}
                      />
                    </Col>
                  )}
                  {[2, 3].includes(form.getFieldValue("SiteType")) &&
                    type === "info" && (
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <CustomInput
                          label="Start Time"
                          name="StartTime"
                          disabled
                          loading={loading}
                        />
                      </Col>
                    )}
                  {[2, 3].includes(form.getFieldValue("SiteType")) &&
                    type === "info" && (
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <CustomInput
                          label="End Time"
                          name="EndTime"
                          disabled
                          loading={loading}
                        />
                      </Col>
                    )}
                </Row>
              </div>
            </div>
          }
          <div className="mt-4 border bg-white rounded-[4px] overflow-hidden">
            <div className="flex items-center bg-gray-200 p-2.5">
              <InfoCircleOutlined className="text-[18px] text-black " />
              <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                License Information
              </span>
            </div>
            <div className="px-2 pt-1 pb-3">
              <Row gutter={[16, 8]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomSelect
                    label="Model"
                    name="Model"
                    options={modifiedModels}
                    placeholder="Please select"
                    disabled={type === "info" || userData?.role_value >= 10}
                    required
                    loading={loading}
                  />
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Door"
                    name="Type"
                    disabled={type === "info"}
                    type="number"
                    required
                    loading={loading}
                    rules={[
                      {
                        required: true,
                        message: "Door is required",
                      },
                      {
                        validator: (_, value) => {
                          if (value && value > 65535) {
                            return Promise.reject(
                              new Error(
                                "Door must be less than or equal to 65535!"
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  />
                </Col>
              </Row>
            </div>
          </div>
          <div className="mt-4 border bg-white rounded-[4px] overflow-hidden">
            <div className="flex items-center bg-gray-200 p-2.5">
              <SettingOutlined className="text-[18px] text-black " />
              <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                License Options
              </span>
            </div>
            <div className="px-2 py-3 grid gap-4">
              <CustomCheckbox
                label=""
                name="Options"
                options={modifiedOp}
                disabled={type === "info"}
              />
              {/* {modifiedOp?.length > 0 && (
                <SingleSelectCheckboxGroup
                  options={modifiedOp}
                  type={
                    type === "edit"
                      ? userData?.role_value >= 10
                        ? "info"
                        : "edit"
                      : type
                  }
                  name="Options"
                  onChange={(vals) => setSelectedValues(vals)}
                  defaultOptionsValue={selectedValues}
                  staticOptions={defaultOptionsValue}
                  disabled={type === "info" || userData?.role_value >= 10}
                />
              )} */}
            </div>
          </div>

          <div className="mt-4 border bg-white rounded-[4px] overflow-hidden">
            <div className="flex items-center bg-gray-200 p-2.5">
              <DesktopOutlined className="text-[18px] text-black " />
              <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                License Devices
              </span>
            </div>

            <div className="px-2 pt-1 pb-3">
              <Row gutter={[16, 8]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Channel"
                    name="Channel"
                    disabled={type === "info"}
                    type="number"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (value && value > 255) {
                            return Promise.reject(
                              new Error(
                                "Channel must be less than or equal to 255!"
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                    loading={loading}
                  />
                  {/* <CustomSelect
                    label="Channel"
                    name="Channel"
                    options={
                      // isChannelOneTime
                      //   ? modifiedChannels.filter((item) =>
                      //       item.label?.includes("One Time")
                      //     )
                      //   :
                      modifiedChannels
                    }
                    placeholder="Please select"
                    disabled={type === "info" || userData?.role_value >= 10}
                  /> */}
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Lockset"
                    name="Lockset"
                    disabled={type === "info"}
                    type="number"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (value && value > 255) {
                            return Promise.reject(
                              new Error(
                                "Lockset must be less than or equal to 255!"
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                    loading={loading}
                  />
                  {/* <CustomSelect
                    label="Lockset"
                    name="Lockset"
                    options={
                      // isLocksetOneTime
                      // ? modifiedLocksets.filter((item) =>
                      //     item.label?.includes("One Time")
                      //   )
                      // :
                      modifiedLocksets
                    }
                    placeholder="Please select"
                    disabled={type === "info" || userData?.role_value >= 10}
                  /> */}
                </Col>

                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Facegate"
                    name="Facegate"
                    disabled={type === "info"}
                    type="number"
                    loading={loading}
                    rules={[
                      {
                        validator: (_, value) => {
                          if (value && value > 255) {
                            return Promise.reject(
                              new Error(
                                "Facegate must be less than or equal to 255!"
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  />
                  {/* <CustomSelect
                    label="Facegate"
                    name="Facegate"
                    options={
                      // isFacegatesOneTime
                      //   ? modifiedFacegates.filter((item) =>
                      //       item.label?.includes("One Time")
                      //     )
                      //   :
                      modifiedFacegates
                    }
                    placeholder="Please select"
                    disabled={type === "info" || userData?.role_value >= 10}
                  /> */}
                </Col>

                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="OSDP Device"
                    name="Subnode"
                    disabled={type === "info"}
                    type="number"
                    loading={loading}
                    rules={[
                      {
                        validator: (_, value) => {
                          if (value && value > 255) {
                            return Promise.reject(
                              new Error(
                                "OSDP Device must be less than or equal to 255!"
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  />
                  {/* <CustomSelect
                    label="OSDP Device"
                    name="Subnode"
                    options={
                      // isSubnodesOneTime
                      //   ? modifiedSubnodes.filter((item) =>
                      //       item.label?.includes("One Time")
                      //     )
                      //   :
                      modifiedSubnodes
                    }
                    placeholder="Please select"
                    disabled={type === "info" || userData?.role_value >= 10}
                  /> */}
                </Col>

                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Trilogy Lockset"
                    name="ContLock"
                    disabled={type === "info"}
                    type="number"
                    loading={loading}
                    rules={[
                      {
                        validator: (_, value) => {
                          if (value && value > 255) {
                            return Promise.reject(
                              new Error(
                                "Trilogy Lockset must be less than or equal to 255!"
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  />
                  {/* <CustomSelect
                    label="Trilogy Lockset"
                    name="ContLock"
                    options={
                      // isContLocksOneTime
                      //   ? modifiedContLocks.filter((item) =>
                      //       item.label?.includes("One Time")
                      //     )
                      //   :
                      modifiedContLocks
                    }
                    placeholder="Please select"
                    disabled={type === "info" || userData?.role_value >= 10}
                  /> */}
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomInput
                    label="Intercom"
                    name="Intercom"
                    loading={loading}
                    disabled={type === "info"}
                    type="number"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (value && value > 255) {
                            return Promise.reject(
                              new Error(
                                "Intercom must be less than or equal to 255!"
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  />
                  {/* <CustomSelect
                    label="Intercom"
                    name="Intercom"
                    options={
                      // isIntercomsOneTime
                      //   ? modifiedIntercoms.filter((item) =>
                      //       item.label?.includes("One Time")
                      //     )
                      //   :
                      modifiedIntercoms
                    }
                    placeholder="Please select"
                    disabled={type === "info" || userData?.role_value >= 10}
                  /> */}
                </Col>

                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomSelect
                    label="Directory Extension"
                    name="Sicucom"
                    options={Array.from(
                      { length: (25500 - 100) / 100 + 1 },
                      (_, i) => {
                        const value = 100 + i * 100;
                        return {
                          value,
                          label: `${value}`,
                        };
                      }
                    )}
                    placeholder="Please select"
                    loading={loading}
                    disabled={type === "info"}
                  />
                  {/* <CustomSelect
                    label="Directory"
                    name="Sicucom"
                    options={
                      // isSicucomsOneTime
                      //   ? modifiedSicucoms.filter((item) =>
                      //       item.label?.includes("One Time")
                      //     )
                      //   :
                      modifiedSicucoms
                    }
                    placeholder="Please select"
                    disabled={type === "info" || userData?.role_value >= 10}
                  /> */}
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomSelect
                    label="Mobile Credential"
                    name="Invitation"
                    loading={loading}
                    options={Array.from(
                      { length: (25500 - 100) / 100 + 1 },
                      (_, i) => {
                        const value = 100 + i * 100;
                        return {
                          value,
                          label: `${value}`,
                        };
                      }
                    )}
                    placeholder="Please select"
                    disabled={type === "info"}
                  />
                  {/* <CustomSelect
                    label="Invitation"
                    name="Invitation"
                    options={
                      // isInvitationsOneTime
                      //   ? modifiedInvitations.filter((item) =>
                      //       item.label?.includes("One Time")
                      //     )
                      //   :
                      modifiedInvitations
                    }
                    placeholder="Please select"
                    disabled={type === "info" || userData?.role_value >= 10}
                  /> */}
                </Col>
              </Row>

              {/* <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <CustomSelect
                    label="Storage"
                    name="Storage"
                    options={
                      // isStoragesOneTime
                      //   ? modifiedStorages.filter((item) =>
                      //       item.label?.includes("One Time")
                      //     )
                      //   :
                      modifiedStorages
                    }
                    placeholder="Please select"
                    disabled={type === "info" || userData?.role_value >= 10}
                  />
                </Col>
              </Row> */}
            </div>
          </div>
          {/* <div className="mt-4 overflow-hidden border bg-white rounded-[4px]">
            <div className="flex items-center bg-gray-200 p-2.5">
              <FaUserTag className="text-[18px] text-black " />
              <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                My Site
              </span>
            </div>
            <div className="px-2 pt-1 pb-3">
              <Row gutter={[16, 8]}></Row>
            </div>
          </div> */}

          {type === "info" && data?.data?.Guest ? (
            <div className="mt-4 bg-white rounded-[4px] overflow-hidden">
              <div className="flex items-center bg-gray-200 p-2.5 ">
                <InfoCircleOutlined className="text-[18px] text-black " />
                <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                  Customer Information
                </span>
              </div>
              <div className="px-2 pt-1 pb-3">
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="First Name"
                      name="FirstName"
                      disabled={type === "info"}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Last Name"
                      name="LastName"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Installing Company"
                      name="Company"
                      disabled={type === "info"}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Email"
                      name="Email"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Phone"
                      name="Phone"
                      disabled={type === "info"}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Address"
                      name="Address2"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Install Type"
                      name="InstallType"
                      disabled={type === "info"}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Suggestion"
                      name="Suggestion"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          ) : null}

          {type === "info" &&
            ![3, 4].includes(form.getFieldValue("SiteType")) && (
              <div className="mt-4 bg-white rounded-[4px] overflow-hidden">
                <div className="flex items-center bg-gray-200 p-2.5 ">
                  <InfoCircleOutlined className="text-[18px] text-black " />
                  <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                    Status
                  </span>
                </div>
                <div className="px-2 pt-1 pb-3">
                  <Row gutter={[16, 8]}>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Proxy Server"
                        name="ProxyServer"
                        disabled={type === "info"}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Secure Port"
                        name="SecurePort"
                        disabled={type === "info"}
                      />
                    </Col>

                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Debug Port"
                        name="DebugPort"
                        disabled={type === "info"}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Version"
                        name="Version"
                        disabled={type === "info"}
                      />
                    </Col>
                    {/* <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Timeout"
                      name="Timeout"
                      disabled={type === "info"}
                    />
                  </Col> */}

                    {/* <Row gutter={[16, 16]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomInput
                      label="Debug"
                      name="Debug"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row> */}

                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Address"
                        name="Address"
                        disabled={type === "info"}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="HTTPS"
                        name="Https"
                        disabled={type === "info"}
                      />
                    </Col>

                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Timezone"
                        name="Timezone"
                        disabled={type === "info"}
                      />
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                      <CustomInput
                        label="Online"
                        name="Online"
                        disabled={type === "info"}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            )}
          {[2, 3, 4].includes(form.getFieldValue("SiteType")) && (
            <div className="mt-4 border bg-white rounded-[4px] overflow-hidden">
              <div className="flex items-center bg-gray-200 p-2.5">
                <LoginOutlined className="text-[18px] text-black " />
                <span className="text-[.935rem] text-black font-['Poppins'] ml-2">
                  Authentication
                </span>
              </div>

              <div className="px-2 pt-1 pb-3">
                <Row gutter={[16, 8]}>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomSelect
                      label="Auto Login"
                      name="AutoLogin"
                      options={[
                        { label: "Yes", value: 1 },
                        { label: "No", value: 0 },
                      ]}
                      placeholder="Please select"
                      disabled={type === "info"}
                      onChange={(value) => {
                        setAutoLogin(value);
                      }}
                    />
                  </Col>
                  {autoLogin === 1 && (
                    <>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <CustomInput
                          label="Username"
                          name="UserId"
                          disabled={type === "info"}
                          autoComplete="off"
                          required
                        />
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        <CustomInput
                          label="Password"
                          name="Password"
                          type="password"
                          disabled={type === "info"}
                          autoComplete="new-password"
                          required
                          noValidation
                        />
                      </Col>
                    </>
                  )}
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <CustomSelect
                      label="Blocked"
                      name="Blocked"
                      options={[
                        { label: "Yes", value: 1 },
                        { label: "No", value: 0 },
                      ]}
                      placeholder="Please select"
                      disabled={type === "info"}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          )}
        </Form>
      </div>

      <ConfirmModal
        showModal={showModal}
        setShowModal={setShowModal}
        onDeleteConfirm={onDeleteConfirm}
      />
    </div>
  );
};
